/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OAuthBindEmailReqVo
 */
export interface OAuthBindEmailReqVo {
    /**
     * 绑定凭证
     * OAuth绑定凭证
     * @type {string}
     * @memberof OAuthBindEmailReqVo
     */
    oauthBindToken: string;
    /**
     * 已注册会员邮箱
     * 已注册会员邮箱
     * @type {string}
     * @memberof OAuthBindEmailReqVo
     */
    email: string;
    /**
     * 邮箱验证码
     * 邮箱验证码
     * @type {string}
     * @memberof OAuthBindEmailReqVo
     */
    verificationCode: string;
}

/**
 * Check if a given object implements the OAuthBindEmailReqVo interface.
 */
export function instanceOfOAuthBindEmailReqVo(value: object): value is OAuthBindEmailReqVo {
    if (!('oauthBindToken' in value) || value['oauthBindToken'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('verificationCode' in value) || value['verificationCode'] === undefined) return false;
    return true;
}

export function OAuthBindEmailReqVoFromJSON(json: any): OAuthBindEmailReqVo {
    return OAuthBindEmailReqVoFromJSONTyped(json, false);
}

export function OAuthBindEmailReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthBindEmailReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'oauthBindToken': json['oauthBindToken'],
        'email': json['email'],
        'verificationCode': json['verificationCode'],
    };
}

export function OAuthBindEmailReqVoToJSON(json: any): OAuthBindEmailReqVo {
    return OAuthBindEmailReqVoToJSONTyped(json, false);
}

export function OAuthBindEmailReqVoToJSONTyped(value?: OAuthBindEmailReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'oauthBindToken': value['oauthBindToken'],
        'email': value['email'],
        'verificationCode': value['verificationCode'],
    };
}

